var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25C11.07 5.25 12.75 6.93 12.75 9C12.75 9.4875 12.6525 9.945 12.48 10.3725L14.67 12.5625C15.8025 11.6175 16.695 10.395 17.2425 9C15.945 5.7075 12.7425 3.375 8.9925 3.375C7.9425 3.375 6.9375 3.5625 6.0075 3.9L7.6275 5.52C8.055 5.3475 8.5125 5.25 9 5.25ZM1.5 3.2025L3.21 4.9125L3.555 5.2575C2.31 6.225 1.335 7.515 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C10.1625 14.625 11.2725 14.4 12.285 13.995L12.6 14.31L14.7975 16.5L15.75 15.5475L2.4525 2.25L1.5 3.2025ZM5.6475 7.35L6.81 8.5125C6.7725 8.67 6.75 8.835 6.75 9C6.75 10.245 7.755 11.25 9 11.25C9.165 11.25 9.33 11.2275 9.4875 11.19L10.65 12.3525C10.1475 12.6 9.5925 12.75 9 12.75C6.93 12.75 5.25 11.07 5.25 9C5.25 8.4075 5.4 7.8525 5.6475 7.35ZM8.88 6.765L11.2425 9.1275L11.2575 9.0075C11.2575 7.7625 10.2525 6.7575 9.0075 6.7575L8.88 6.765Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f759fd13df787a66cf76dea7612ba3e7.svg";
export { ForwardRef as ReactComponent };